import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updatePropertyInput } from '../PropertyActions';
import { Form, Card, CardBody, Button, Alert } from 'reactstrap';
import { InputQuestionCurrency, InputQuestionPercent, InputQuestionText, InputQuestionSelect, InputQuestionSelectOption } from '../../../components/Inputs/InputQuestions';

export class GoalsWizardPage extends Component {
    /*limitedChanged(event) {
        this.props.updatePropertyInput('purchaseLimited', event.target.name === 'limited');
    }*/

    render() {
        const values = this.props.values;

        return (
            <React.Fragment>
                <h2>Your goals and other income</h2>
                <p>
                    <em>
                        We need this information to forecast the tax due on your profits.
                    </em>
                </p>
                <p>
                    <em>
                        Remember: tax is complicated.
                        We're tried to make this calculator as accurate as possible, but tax is complicated. For more accurate advice, please contact us.
                    </em>
                </p>
                <Form>
                    <InputQuestionSelect name="goal" value={values.goal} title="Your property goal" onChange={this.props.onChangeHandler}>
                        <InputQuestionSelectOption name="Buy another property after this one" value='nextProperty' />
                        <InputQuestionSelectOption name="Save the profits and build a nest-egg" value='retain' />
                        <InputQuestionSelectOption name="Generate a regular income" value='income' />
                    </InputQuestionSelect>

                    {
                        values.goal === 'nextProperty' &&
                        <React.Fragment>
                            <InputQuestionCurrency name="profitGoal" value={values.profitGoal} title="How much do you need to buy your next property?" onChange={this.props.onChangeHandler} />
                            <InputQuestionCurrency name="additionalAnnualInvestment" value={values.additionalAnnualInvestment} title="How much of your own savings will you contribute each year?" onChange={this.props.onChangeHandler} />
                        </React.Fragment>
                    }

                    {/*
                        values.goal === 'retain' &&
                        <InputQuestionSelect name="projectionYears" value={values.projectionYears} title="How long do you want to save for?" onChange={this.props.onChangeHandler}>
                            <InputQuestionSelectOption name="5 years" value='5' />
                            <InputQuestionSelectOption name="10 years" value='10' />
                            <InputQuestionSelectOption name="15 years" value='15' />
                            <InputQuestionSelectOption name="25 years" value='25' />
                        </InputQuestionSelect>
                    */}
                    <InputQuestionCurrency name="nonPropertyEarnings" value={values.nonPropertyEarnings} title="Your gross income / earnings, per year" onChange={this.props.onChangeHandler} />
                    <InputQuestionCurrency name="nonPropertyDividendIncome" value={values.nonPropertyDividendIncome} title="Your income from dividends, per year" onChange={this.props.onChangeHandler} />
                    {/*<InputQuestionRadioButtonGroup title="Purchase" selectedValue={this.props.purchaseLimited ? 'limited' : 'personal'} onClick={this.limitedChanged}>
                        <InputQuestionRadioButton title="Personal" name='personal' />
                        <InputQuestionRadioButton title="Limited" name='limited' />
                    </InputQuestionRadioButtonGroup>*/}
                </Form>
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/Components/GoalsAndIncomeWizardPage.jsx